import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AlertService {
    private subject = new Subject<any>();

    success(message: string, value: boolean = false) {
        this.subject.next({ type: 'success', text: message });
        if (value === true) {
            window.setTimeout(() => this.clear(), 3000);
        }
    }

    error(message: string, value: boolean = false) {
        this.subject.next({ type: 'danger', text: message });
        if (value === true) {
            window.setTimeout(() => this.clear(), 5000);
        }
    }

    warn(message: string, value: boolean = false) {
        this.subject.next({ type: 'warning', text: message });
        if (value === true) {
            window.setTimeout(() => this.clear(), 3000);
        }
    }

    info(message: string, value: boolean = false) {
        this.subject.next({ type: 'info', text: message });
        if (value === true) {
            window.setTimeout(() => this.clear(), 3000);
        }
    }

    clear() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/alert.service.ts